import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[inputSelectOnFocus]',
    standalone: false
})
export class InputSelectOnFocusDirective {

    constructor(private el: ElementRef) { }

    @HostListener('focus', ['$event'])
    onFocus(event: any) {
        (this.el.nativeElement as HTMLInputElement)?.select();
    }

}